// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 799 ? "app-init" : chunkId) + "." + {"799":"a64daf0f","964":"07c7f25f"}[chunkId] + ".chunk.css";
};